import { Component } from "react";
import { withTranslation, Trans } from "react-i18next";
import config from "@/config";

import { IconLogoMzc } from "@mzc-cloudplex/icons";
import { Box, Typography } from "@mui/material";
import theme from "@styles/theme";
import { StyledWelcome } from "@routes/welcome/styled";
import { Button } from "@mzc-pdc/ui";
import { siteMode } from "@cores/siteMode";
import { sessionKeeper } from "@cores/sessionKeeper";
import Cookies from "js-cookie";
import { ReactComponent as ImgLogo } from "@assets/svg/logo.svg";

class Welcome extends Component {
    constructor(props) {
        super(props);
    }

    onLoginClick = () => {
        localStorage.setItem("CLIENT_ID", config.mz_pops.clientId);
        window.location.href = this.getLoginLink();
    };

    getLoginLink = () => {
        const currentSiteMode = siteMode.get();
        const targetPath = currentSiteMode === "CONSOLE" ? "/spaces" : "/library/spaces";
        const domain = sessionKeeper.getDomain();
        const beforeLoginPath = Cookies.get("beforeLogin", {
            cookieDomain: sessionKeeper.getDomain(),
        });

        if (!beforeLoginPath) {
            Cookies.set("beforeLogin", targetPath, {
                expires: 1,
                path: "/",
                domain,
            });
        }
        const redirectUrl = encodeURIComponent(`${window.location.origin}${config.host.loginRedirectUri}`);
        return `${config.mz_pops.oauth_host}/oauth/authorize?response_type=code&client_id=${config.mz_pops.clientId}&redirect_uri=${redirectUrl}`;
    };

    renderWelcomeMessage = (t) => {
        return (
            <Trans
                i18nKey="common::msg::You need to sign in a {{Megazone Accounts}} {{or}} {{Megazone Login}} account to get started."
                values={{ "Megazone Accounts": "", "Megazone Login": t(`common::label::${"Megazone Login"}`), or: "" }}
            />
        );
    };

    render() {
        const { t, i18n } = this.props;
        return (
            <StyledWelcome>
                <ImgLogo fill={theme.palette.greySecondary.main} style={{ width: "335px", height: "47px" }} />
                <Box
                    sx={{
                        margin: `40px 0 32px`,
                        padding: `60px 80px`,
                        borderTop: `1px solid ${theme.palette.greySecondary.main}`,
                        borderBottom: `1px solid ${theme.palette.greySecondary[100]}`,
                        color: theme.palette.greySecondary.dark,
                    }}
                >
                    <Typography
                        variant={`subtitle1_700`}
                        component={`p`}
                        sx={{ textAlign: `left`, lineHeight: `1.63`, color: theme.palette.greySecondary.main }}
                    >
                        {t(`common::label::${"Welcome"}`, `Welcome`)}!
                        <br />
                        {t(
                            `common::msg::${"Megazone Login users, please sign in through the button below."}`,
                            `Megazone Login users, please sign in through the button below.`,
                        )}
                    </Typography>
                    <Button
                        size={"large"}
                        variant={"contained"}
                        color={"inherit"}
                        fullWidth
                        startIcon={
                            <IconLogoMzc
                                size={24}
                                htmlColor={theme.palette.background.paper}
                                style={{ marginRight: `16px` }}
                            />
                        }
                        onClick={(e) => {
                            e.preventDefault();
                            this.onLoginClick();
                        }}
                        sx={{
                            mt: 6,
                            backgroundColor: theme.palette.greySecondary.dark,
                            "&:hover, &:active": {
                                backgroundColor: theme.palette.greySecondary.dark,
                            },
                        }}
                    >
                        <Typography variant={"subtitle1_400"} color={theme.palette.background.paper}>
                            {t(`common::label::${"Sign in with Megazone Login"}`, `Sign in with Megazone Login`)}
                        </Typography>
                    </Button>
                </Box>
                <Typography variant={"body3_400"} color={theme.palette.greySecondary[600]}>
                    {t(
                        `common::msg::${"If you don’t have an account yet, please ask your Organization Administrator."}`,
                        `If you don’t have an account yet, please ask your Organization Administrator.`,
                    )}
                </Typography>
            </StyledWelcome>
        );
    }
}

export default withTranslation()(Welcome);
